import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

export interface UpdateCoOwnerDto {
  applicationId: string;
  phoneNumber: string;
  dateOfBirth: string;
  ssn: string;
  email: string;
}

export default class CoOwnersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/coOwners' || '');
  }

  public async updateInformation(updateCoOwnerDto: UpdateCoOwnerDto): Promise<void> {
    return this.instance.put('/update', updateCoOwnerDto).then((response: AxiosResponse<void>) => response.data);
  }
}

export const coOwnersApi = new CoOwnersApi();
